import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const Check: FC<IconProps> = ({ width = 16, height = 16, fill = '#111026', fillBg = 'white', className }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <rect width="16" height="16" rx="8" fill={fillBg} />
      <path
        d="M4.44434 7.55561L7.111 10.2223L11.5554 5.77783"
        stroke={fill}
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
